export enum MovementState {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  ACCEPTED = 'ACCEPTED',
  CONTESTED = 'CONTESTED',
  REFUSED = 'REFUSED',
  CANCELED = 'CANCELED',
  FINALIZED = 'FINALIZED',
  REALIZED = 'REALIZED',
}
